// Deep import needed to avoid client components in server contexts
import { tileMinWidth } from '@carvana/merch-tile/constants/TileVariables';
import React from 'react';
import styles from './ResultsSection.module.css';

export default function StyledResultsSection({
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={styles.wrapper}>
      <div
        className="results-section"
        style={
          { '--tile-min-width': `${tileMinWidth}px` } as React.CSSProperties
        }
        {...props}
      >
        {children}
      </div>
    </div>
  );
}
